import React, { useRef } from "react";
import { getMathJaxNode } from "../../mathjax/MathJax";

const Process2 = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const changedDataCount = props.data.filter( ( v, i ) => prevData.current[ i ] !== v ).length;

  const MathJaxNode = getMathJaxNode( props.type );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = props.data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  return (
    <table className="tbl-factorization mt10">
      <tbody>
      <tr className="last">
        <td className="fact-divisor" />
        <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 0 ] || '' }</MathJaxNode></span></td>
        <td>=</td>
        <td><span className="dividend_box pr0"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 1 ] || '' }</MathJaxNode></span></td>
        <td>.</td>
        <td className="align_l"><span className="dividend_box pl0"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 2 ] || '' }</MathJaxNode></span></td>
      </tr>
      <tr>
        <td className="fact-divisor">
          <span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 3 ] || '' }</MathJaxNode></span>
          <span className="curvedline" />
        </td>
        <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 4 ] || '' }</MathJaxNode></span></td>
        <td>=</td>
        <td><span className="dividend_box pr0"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 5 ] || '' }</MathJaxNode></span></td>
        <td>.</td>
        <td className="align_l"><span className="dividend_box pl0"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 6 ] || '' }</MathJaxNode></span></td>
      </tr>
      <tr className="last">
        <td className="fact-divisor" />
        <td><span className="dividend_box"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 7 ] || '' }</MathJaxNode></span></td>
        <td>=</td>
        <td><span className="dividend_box pr0"><MathJaxNode onRender={ renderMathJax }>{ props.data[ 8 ] || '' }</MathJaxNode></span></td>
        <td />
        <td />
      </tr>
      </tbody>
    </table>
  );

};

export default Process2;
